import React from "react";
import Title from "../home/Title";
import AboutMe from "./AboutMe";
import FunFact from "./FunFact";
import MyServices from "./MyServices";

const About = () => {
  return (
    <section id="about" className="w-full py-14 bg-gray-900">
      <div className="container mx-auto px-4">
        <Title title="Обо" subTitle="Мне" />
        <AboutMe />
        <div className="my-16">
          <Title title="Мои" subTitle="Услуги" />
          <MyServices />
        </div>
        <Title title="Мои" subTitle="Достижения" />
        <FunFact />
      </div>
    </section>
  );
};

export default About;